import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCards = ({ metrics }) => {
  const cards = [
    {
      title: 'Active Investigations',
      value: metrics?.activeInvestigations || 0,
      change: '+12%',
      changeType: 'positive',
      icon: 'Search',
      color: 'bg-primary',
      description: 'Currently ongoing cases'
    },
    {
      title: 'Funds Traced',
      value: `$${metrics?.totalFundsTraced || '0.00'}M`,
      change: '+$2.3M',
      changeType: 'positive', 
      icon: 'DollarSign',
      color: 'bg-success',
      description: 'Total cryptocurrency traced'
    },
    {
      title: 'Flagged Addresses',
      value: metrics?.flaggedAddresses || 0,
      change: '+8',
      changeType: 'neutral',
      icon: 'Flag',
      color: 'bg-warning',
      description: 'Addresses marked as suspicious'
    },
    {
      title: 'Completed Cases',
      value: metrics?.completedInvestigations || 0,
      change: '+5',
      changeType: 'positive',
      icon: 'CheckCircle',
      color: 'bg-accent',
      description: 'Successfully closed investigations'
    }
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      default:
        return 'text-text-secondary';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-forensic-card hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${card?.color}/10`}>
              <Icon 
                name={card?.icon} 
                size={24} 
                color={`var(--color-${card?.color?.replace('bg-', '')})`}
                strokeWidth={2}
              />
            </div>
            <div className={`text-sm font-medium ${getChangeColor(card?.changeType)} flex items-center space-x-1`}>
              <Icon 
                name={card?.changeType === 'positive' ? 'TrendingUp' : card?.changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
                size={14} 
                color="currentColor"
              />
              <span>{card?.change}</span>
            </div>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-text-primary">{card?.value}</h3>
            <p className="text-sm font-medium text-text-primary">{card?.title}</p>
            <p className="text-xs text-text-secondary">{card?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsCards;